import React, { useEffect } from 'react';

import { useAtom } from 'jotai/index';

import { Alert } from '@consumer-frontend/shared-ui';

import { alertBannerAtom, initialAlertBannerProps } from '../../store';

import '@consumer-bootstrap/index.scss';

export const AlertBanner = () => {
  const [
    {
      dismissible,
      heading,
      message,
      show,
      variant,
    },
    setAlertBanner,
  ] = useAtom(alertBannerAtom);

  useEffect(() => {
    setAlertBanner(initialAlertBannerProps);
  }, [setAlertBanner]);

  return show && (
    <Alert className="alert-banner" dismissible={dismissible} variant={variant}>
      <>
        <p className="banner-heading">{heading}</p>
        <p>{message}</p>
      </>
    </Alert>
  );
};
